import { styled } from "@mui/material/styles";
import { Grid, Link, Collapse } from "@mui/material";

const linkStyles = (theme) => ({
  padding: "5px 16px 25px",
  position: "relative",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  fontWeight: 500,
  "&:hover": {
    "&::after": {
      display: "block",
      position: "absolute",
      content: "''",
      width: "100%",
      background: theme.palette.primary.main,
      height: "3px",
      bottom: "-16px",
    },
  },
  "&#ecards, &#ai-image-packs, & #button-invitations": {
    fontWeight: "bold",
    color: theme.palette.primary.main,
  },
  "&:first-of-type": {
    paddingLeft: 0,
  },
  "&:last-child": {
    paddingRight: 0,
  },
  [theme.breakpoints.up("tablet")]: {
    padding: 0,
    marginRight: 24,
    "&:last-child": {
      marginRight: 0,
    },
  },
});

export const StyledLink = styled(Link)(({ theme }) => ({
  ...linkStyles(theme),
}));

const activeLinkStyles = (theme) => ({
  "&::after": {
    display: "block",
    position: "absolute",
    content: "''",
    width: "100%",
    background: theme.palette.primary.main,
    height: "3px",
    bottom: "-16px",
  },
});

export const InternalStyledLink = styled(Link)(({ theme }) => ({
  ...linkStyles(theme),
  "&.active": {
    ...activeLinkStyles(theme),
  },
}));

export const StyledGrid = styled(Grid, { shouldForwardProp: (prop) => prop !== "hasActiveSubLink" })(
  ({ theme, hasActiveSubLink }) => ({
    ...linkStyles(theme),
    ...(hasActiveSubLink && activeLinkStyles(theme)),
  }),
);

export const SubMenuCollapse = styled(Collapse)({
  position: "absolute",
  boxShadow: "0 5px 5px #00000030",
  top: 44,
});
